import { TransferForm } from '@/features/transfers/components/TransferForm';
import styles from './TransfersPage.module.css';

export default function TransfersPage() {
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Transferencias</h1>
      <div className={styles.container}>
        <TransferForm />
      </div>
    </div>
  );
}

export { TransfersPage };
